import { Component, OnInit } from '@angular/core';
import { MeteorObservable } from 'meteor-rxjs';
import { Observable } from 'rxjs';
import { NavController, AlertController } from 'ionic-angular';
import { HttpService } from '../../services/httpService';
import { Companies } from 'api/collections';
import { Company } from 'api/models';
import { AuthenticationService } from '../../services/congito';
import { SharedService } from '../../services/sharedService';

@Component({
  template: `
    <ion-content class="companies-page-content">
      <ion-list class="companies">
        <ion-item *ngFor="let company of companies | async">
          <button ion-item class="company" (click)="selectCompany(company)">
            <div class="company-info">
              <img class="company-picture" [src]="getPic(company.pictureId)">
              <h2 class="company-name">Name: {{company.name}}</h2>
              <h3 class="company-code">Code: {{company.code}}</h3>
            </div>
          </button>
        </ion-item>
      </ion-list>
    </ion-content>
  `,
})
export class ChooseActiveCompany implements OnInit {
 	companies: Observable<Company[]>;

  constructor(
    private navCtrl: NavController,
    private alertCtrl: AlertController,
    public httpService: HttpService,
    private sharedService: SharedService,
    public authenticationService: AuthenticationService
  ) {
  }

  ngOnInit() {
    console.log('choose active company page');
    this.httpService.MeteorSubscribe('userCompanies');
    this.httpService.privateLoopAction(true).then(res=>{
      MeteorObservable.autorun().subscribe(() => {
        // MeteorObservable.subscribe('userCompanies').subscribe();
        this.httpService.MeteorSubscribe('userCompanies');
        const viewer = this.authenticationService.MeteorUser();
        this.companies = Companies.find({
          memberIds: viewer ? viewer._id: null,
        });
      });
      this.sharedService.collectionUpdated.subscribe(
        async (res: any) => {
          this.httpService.MeteorSubscribe('userCompanies');
          const viewer = this.authenticationService.MeteorUser();
          this.companies = Companies.find({
            memberIds: viewer ? viewer._id: null,
          });
        }
      );

    });

  }

  selectCompany(company: Company): void {
    /*
    MeteorObservable.call('setActiveCompany', company._id).subscribe({
      next: () => {
        this.navCtrl.pop();
      },
    });
    */
    this.httpService.MeteorCall('setActivity, company._id')
      .then(() => {
        this.navCtrl.pop();
      })
      .catch(err => console.log('meteor call error:', err));
  }

  handleError(e: Error): void {
    console.error(e);

    const alert = this.alertCtrl.create({
      buttons: ['OK'],
      message: e.message,
      title: 'Oops!'
    });

    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/components/choose-active-company/choose-active-company.ts